import axios from "axios";
import config from "./config";
import endpoints from "./endoinpts";

function validateNIF(nif) {
  if (nif.length == 9) {
    let added = nif[7] * 2 + nif[6] * 3 + nif[5] * 4 + nif[4] * 5 + nif[3] * 6 + nif[2] * 7 + nif[1] * 8 + nif[0] * 9;
    let mod = added % 11;
    let control;
    if (mod == 0 || mod == 1) {
      control = 0;
    } else {
      control = 11 - mod;
    }

    if (nif[8] == control) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

// Communications recipients used to be stored as a plain array of user ids. They are now stored
// as `{ id, type }` (type is "user" or "guest") so guests can be recipients too. This normalizes
// older records (plain ids) to the new shape so both formats can be handled the same way.
function normalizeRecipients(recipients) {
  return (recipients || []).map((item) => (item !== null && typeof item === "object" ? item : { id: item, type: "user" }));
}

export default { validateNIF, normalizeRecipients };
